<mat-progress-bar
  mode="indeterminate"
  color="accent"
  class="auth-confirm-phone-mb-md"
  *ngIf="isLoading">
</mat-progress-bar>

<p class="auth-confirm-phone-text-secondary auth-confirm-phone-text-left">
  {{ 'auth.confirmPhone.message' | t }}
  <span class="auth-confirm-phone-text-nowrap">{{ phone$ | async }}</span>
</p>

<form name="confirmPhone" [formGroup]="form" (submit)="confirmPhone()" novalidate>
  <sn-form [form]="form" [(model)]="formModel" [fields]="formFields" [options]=""></sn-form>

  <div class="auth-confirm-phone-text-right">
    <sn-flat-button [isLoading]="isLoading" type="submit" color="success">{{ 'common.next' | t }}</sn-flat-button>
  </div>
</form>
